<template>
  <div class="page page--company-dashboard">
    <div class="company-dashboard__top">
      <div class="company-dashboard__top-group">
        <require-access data="dashboard-company_balance" action="read">
          <dashboard-balance-widget
            :company="selectedCompanyLoading ? {} : selectedCompanyData"
            class="company-dashboard__balance"
          ></dashboard-balance-widget>
        </require-access>
        <require-access data="dashboard-vidjet_conversion" action="read">
          <dashboard-transactions-amount-widget
            :stats="analyticsStats"
            :stats-loading="isTransactionsLoading"
            :company="selectedCompanyLoading ? {} : selectedCompanyData"
            class="company-dashboard__transactions-amount"
          ></dashboard-transactions-amount-widget>
        </require-access>
      </div>
      <require-access data="dashboard-fast_command" action="read">
        <dashboard-fast-commands-widget
          :company="selectedCompanyLoading ? {} : selectedCompanyData"
          class="company-dashboard__fast-actions"
        ></dashboard-fast-commands-widget>
      </require-access>
    </div>
    <div class="company-dashboard__content">
      <dashboard-transactions-list
        :is-transactions-loading="isTransactionsLoading"
        :transactions="transactions"
      ></dashboard-transactions-list>
    </div>
  </div>
</template>

<script>
import DashboardBalanceWidget from '@vue-app/components/company/dashboard/DashboardBalanceWidget.vue'
import DashboardTransactionsAmountWidget from '@vue-app/components/company/dashboard/DashboardTransactionsAmountWidget.vue'
import DashboardFastCommandsWidget from '@vue-app/components/company/dashboard/DashboardFastCommandsWidget.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import DashboardTransactionsList from '@vue-app/components/company/dashboard/DashboardTransactionsList.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'CompanyDashboard',
  components: {
    RequireAccess,
    DashboardTransactionsList,
    DashboardFastCommandsWidget,
    DashboardTransactionsAmountWidget,
    DashboardBalanceWidget,
  },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      filterObject: {
        dates: {
          from: moment().subtract(1, 'days').toDate(),
          to: moment().toDate(),
        },
      },
      analyticsStats: {},
      analyticsTransactions: [],
      isTransactionsLoading: false,
    }
  },
  created() {
    this.loadAnalytics()
  },
  computed: {
    ...mapState([
      'selectedCompanyData',
      'selectedCompanyLoading',
      'selectedCompany',
    ]),
    transactions() {
      if (this.analyticsTransactions.length > 10) {
        return this.analyticsTransactions.slice(0, 9)
      } else {
        return this.analyticsTransactions
      }
    },
    dataRequestObject() {
      return {
        date_from: moment(this.filterObject.dates.from).format(
          'YYYY-MM-DD 00:00:00'
        ),
        date_to: moment(this.filterObject.dates.to).format(
          'YYYY-MM-DD 23:59:59'
        ),
      }
    },
  },
  methods: {
    async loadAnalytics() {
      try {
        this.isTransactionsLoading = true
        let _analyticsDataResponse = await CompaniesApi.getCompanyAnalytics(
          this.selectedCompany,
          this.dataRequestObject
        )

        this.analyticsTransactions =
          _analyticsDataResponse.data.ReportOperations || []
        this.analyticsStats =
          _analyticsDataResponse.data?.Stats?.OperationTypeIDStats || {}
      } catch (e) {
        console.error('failed load analytics data', e)
      } finally {
        this.isTransactionsLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--company-dashboard {
    margin-top: 46px;
  }
}
.company-dashboard {
  &__top {
    display: flex;
    align-items: stretch;
    justify-content: space-between;

    &-group {
      display: flex;
      align-items: stretch;
      width: calc(66.666666%);
      margin-right: 22px;
    }
  }

  &__content {
    margin-top: 20px;
  }

  &__balance {
    width: calc(50% - 11px);
    min-width: 150px;
    margin-right: 22px;
    min-height: 301px;
  }

  &__transactions-amount {
    width: calc(50% - 11px);
    min-height: 301px;
  }

  &__fast-actions {
    width: calc(33.33333% - 22px);
    min-height: 301px;
  }
}
@media screen and (max-width: 992px) {
  .company-dashboard {
    &__top {
      display: flex;
      flex-direction: column;

      &-group {
        width: calc(100% + 40px);
        margin-left: -20px;
        padding: 0 20px;
        margin-bottom: 20px;
        overflow: auto;
      }
    }

    &__fast-actions {
      width: 100%;
    }

    &__balance {
      min-width: 188px;
    }

    &__transactions-amount {
      min-width: 335px;
    }
  }
}
</style>
